export const OrderHistoryColumns = [
    {
        header: "OrderHistory.OrderId",
        name: "orderId",
        sortProperty: "OrderId"
    },
    {
        header: "OrderHistory.OrderNumber",
        name: "orderNumber",
        sortProperty: "OrderNumber"
    },
    {
        header: "OrderHistory.ActionType",
        name: "actionType",
        sortProperty: "ActionType"
    },
    {
        header: "OrderHistory.Description",
        name: "description",
        sortProperty: "Description",
        style: {textAlign: 'left', whiteSpace: 'pre-line' }
    },
    {
        header: "OrderHistory.PublisherName",
        name: "publisherName",
        sortProperty: "PublisherName"
    },
    {
        header: "OrderHistory.ActionTs",
        name: "actionTs",
        sortProperty: "ActionTs",
        dataType: "datetime"
    }
];

export const OrderHistoryColumnsMobile = [
    {
        header: "OrderHistory.OrderNumber",
        name: "orderNumber",
        sortProperty: "OrderNumber"
    },
    {
        header: "OrderHistory.ActionType",
        name: "actionType",
        sortProperty: "ActionType"
    },
    {
        header: "OrderHistory.Description",
        name: "description",
        sortProperty: "Description",
        style: {textAlign: 'left', whiteSpace: 'pre-line' }
    },
    {
        header: "OrderHistory.PublisherName",
        name: "publisherName",
        sortProperty: "PublisherName"
    },
    {
        header: "OrderHistory.ActionTs",
        name: "actionTs",
        sortProperty: "ActionTs",
        dataType: "datetime"
    }
];
